<div class="apps">
  <div class="scrollable-content">
    <div class="content">
      @if (appConfigService.features[AppFeature.MobileDownloads]) {
        <h1>
          {{ 'APPS.MOBILE_APP_ACCESS' | translate }}
        </h1>
        <mat-divider></mat-divider>
        <span>{{ 'APPS.MOBILE_APP_HELP_TEXT' | translate }}</span>
        <div class="stores">
          <div class="store-layout">
            <img [src]="'AppleAppStoreQRcode.png' | assetUrl" />
            <img [src]="'AppleAppStore.png' | assetUrl" />
          </div>
          <div class="store-layout">
            <img [src]="'GooglePlayStoreQRcode.png' | assetUrl" />
            <img [src]="'GooglePlayStore.png' | assetUrl" />
          </div>
        </div>

        <div class="login">
          <div class="qr-code">
            <img [src]="this.appConfigService.loginQRCode$ | async" />
          </div>
          <div class="content">
            <div class="title">{{ 'APPS.MOBILE_LOGIN_TITLE' | translate }}</div>
            <div class="description">
              {{ 'APPS.MOBILE_LOGIN_HELP_TEXT' | translate }}
            </div>
          </div>
        </div>
      }
      @if (appConfigService.features[AppFeature.DesktopDownloads]) {
        <h1>{{ 'APPS.DESKTOP_APP_ACCESS' | translate }}</h1>
        <mat-divider></mat-divider>
        <span>{{ 'APPS.DESKTOP_APP_HELP_TEXT' | translate }}</span>
        <button
          color="primary"
          class="download"
          mat-raised-button
          (click)="downloadWindows()"
          appBrandingColor
          [brandingField]="BrandingField.FieldColorFontIconsListAreaItems">
          <mat-icon>download</mat-icon>{{ 'APPS.DOWNLOAD' | translate }} (Windows)
        </button>
        <button
          color="primary"
          class="download"
          mat-raised-button
          (click)="downloadMacOS()"
          appBrandingColor
          [brandingField]="BrandingField.FieldColorFontIconsListAreaItems">
          <mat-icon>download</mat-icon>{{ 'APPS.DOWNLOAD' | translate }} (macOS)
        </button>
      }
    </div>
  </div>
</div>
